import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import POMasterDetails from '../../../components/SidebarMenuComponents/OAComponent/POMasterDetails';
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function POMasterDetailsPage() {
    const location = useLocation();
    const { poMaster } = location.state;
    return (
        <Page title="  PO Master Details | tiketic" >
          
            <StickyHeader title=" PO Master Details" />
            <ContentStyle>
                <POMasterDetails poMaster={poMaster} />
            </ContentStyle>
        </Page>
    );
}

